export function normalizeResolveMergeConflictBaseBranch(args: {
  baseBranch?: string | null
}): string {
  const trimmed = args.baseBranch?.trim() ?? ""
  // `main` matches the historical server fallback. It is safe as a last resort
  // because the session row normally carries the authoritative PR base branch;
  // this only applies when both session and repository metadata are absent.
  return trimmed.length > 0 ? trimmed : "main"
}

export function buildResolveMergeConflictClientMessageId(args: {
  requestId: string
}): string {
  return `resolve-conflict:${args.requestId}`
}

export function buildResolveMergeConflictInstructionText(args: {
  baseBranch?: string | null
}): string {
  const baseBranch = normalizeResolveMergeConflictBaseBranch({
    baseBranch: args.baseBranch,
  })

  return `Please resolve the merge conflicts in this branch by following these steps:

1. Fetch the latest changes from remote: \`git fetch origin\`
2. Merge the base branch into this branch: \`git merge origin/${baseBranch}\`
3. Examine each conflicted file carefully. Resolve the conflicts by preserving the correct intent of both sides of the changes.
4. After resolving all conflicts, stage the resolved files: \`git add -A\`
5. Complete the merge commit: \`git commit --no-edit\`
6. Push the resolved branch: \`git push origin HEAD\`

Please resolve all conflicts carefully and push when done.`
}
